import { RADAR_CENTER, RADAR_RING_OUTER, RADAR_VIEWBOX_SIZE } from '../../lib/proximity/runtime';

export const VIEWBOX = RADAR_VIEWBOX_SIZE;
export const CENTER = RADAR_CENTER;
/** Readout band below the radar disc — keep tight; list gap lives in Find.js. */
export const READOUT_BAND_HEIGHT = 36;
export const WRAPPER_ASPECT = `${VIEWBOX} / ${VIEWBOX + READOUT_BAND_HEIGHT}`;

/** Avatar radii scaled for max-width 400px (Lynx proportion vs 340px baseline). */
export const PEER_AVATAR_R = 18;
export const PEER_TRACKED_RING_R = 21.5;
export const PEER_HIT_R = 31;
export const PEER_BADGE_R = 9;
export const PEER_BADGE_OFFSET = 14;
export const MAX_DIST_M = 200;
export const IN_RANGE_R = RADAR_RING_OUTER - 14;

export const RING_BASE = [
  { key: 'outer', r: RADAR_RING_OUTER, fillOpacity: 0.03, strokeOpacity: 0.18, innerBound: 95 },
  { key: 'mid', r: 95, fillOpacity: 0.06, strokeOpacity: 0.18, innerBound: 50 },
  { key: 'inner', r: 50, fillOpacity: 0.1, strokeOpacity: 0.18, innerBound: 0 },
];

export const RING_DIM = { strokeOpacity: 0.32, strokeWidth: 0.75, fillBoost: 0.07 };
export const RING_BRIGHT = { strokeOpacity: 0.55, strokeWidth: 1, fillBoost: 0.15 };

export const EASE = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

/** One puck skin, everywhere (src/lib/map/peerPuck.js is the source): fill = identity, presence lives in words. */
export const PEER_SKIN = { stroke: '#9a49d2', strokeWidth: 1, casing: '#120a1e', casingR: 19.4 };

/** Ring highlight scale — visual only; peer positions use engine geometry. */
export const radiusForDistance = (dist) =>
  dist == null ? IN_RANGE_R : Math.min(RADAR_RING_OUTER, (dist / MAX_DIST_M) * RADAR_RING_OUTER);

/** Subtext staleness tiers — applied to date/age line only, not the main readout. */
export const STALENESS_FRESH_MS = 5 * 60 * 1000;
export const STALENESS_WARNING_MS = 15 * 60 * 1000;
export const STALENESS_STALE_MS = 60 * 60 * 1000;

export const STALENESS_COLOR_FRESH = '#22c55e';
export const STALENESS_COLOR_NEUTRAL = '#94a3b8';
export const STALENESS_COLOR_WARNING = '#f59e0b';
export const STALENESS_COLOR_STALE = '#ef4444';

export function stalenessSubtextColor(gpsLastKnownAt, now = Date.now()) {
  if (gpsLastKnownAt == null) {
    return STALENESS_COLOR_NEUTRAL;
  }
  const ageMs = now - gpsLastKnownAt;
  if (ageMs < STALENESS_FRESH_MS) {
    return STALENESS_COLOR_FRESH;
  }
  if (ageMs < STALENESS_WARNING_MS) {
    return STALENESS_COLOR_NEUTRAL;
  }
  if (ageMs < STALENESS_STALE_MS) {
    return STALENESS_COLOR_WARNING;
  }
  return STALENESS_COLOR_STALE;
}
